<template>
  <div class="my-1 card">
    <div class="my-0 py-1 card-header text-info">
      <h4 class="my-0 py-1">
        Generate the {{ this.$store.getters.selectedDocumenttype }}
      </h4>
      <small class="form-text text-muted"
        >For the selected Client
        <strong>{{ this.$store.getters.selectedClient.name }}</strong></small
      >
    </div>
    <div class="card-body">
      <!-- <div class="pb-3">
        <label>Client Name</label>
        <vue-bootstrap-typeahead
          v-model="selectedClient"
          :data="this.sowClients"
          @hit="getClientSows"
          ref="typeahead"
        />
      </div> -->
      <div class="clientsows">
        <div v-if="activeSows.length > 0" class="row">
          <div
            class="col-sm-5 ml-3 d-inline-block sowcard p-0 mb-3 border-info card bg-white text-info"
            v-bind:key="sow.id"
            v-bind:slug="sow.slug"
            v-for="sow in activeSows"
          >
            <div class="lfcard p-1 text-nowrap card-body">
              <div>
                <h6
                  :title="sow.clientName"
                  class="d-inline-block card-title font-weight-bold"
                >
                  {{ sow.clientName.substr(0, 22) }}
                </h6>
                <span
                  class="badge font-weight-bold"
                  v-b-popover.click.top="sow.clientName"
                  v-if="sow.clientName.length > 22"
                  >...</span
                >
              </div>
              <div>
                <span
                  :title="sow.lawfirmTitle"
                  class="d-inline-block card-title font-weight-bold"
                  style="font-size: 12px; margin: 0"
                  >Lawfirm - {{ sow.lawfirmTitle }}</span
                >
              </div>
              <div style="font-size: 12px">
                <span>IncidentType:{{ sow.incidentTypeTitle }}</span
                ><br />
                <span>SubOfferingType:{{ sow.subofferingTypeTitle }}</span>
              </div>
              <div>
                <span
                  class="py-1 px-1 d-inline card mr-1"
                  style="font-size: 12px"
                >
                  <a
                    :href="sow.sowFileInfo.webURl"
                    target="_blank"
                    class="card-link"
                  >
                    <font-awesome-icon
                      class="mx-1 text-info"
                      :icon="['fas', 'file-word']"
                      size="lg"
                    />SoW
                  </a>
                  <font-awesome-icon
                    class="mx-1"
                    :icon="['fas', 'download']"
                    @click="handleDownload(sow.sowFileInfo)"
                    size="sm"
                  />
                </span>
                <span
                  class="py-1 px-1 d-inline card mr-1"
                  v-if="sow.msaFileInfo"
                  style="font-size: 12px"
                >
                  <a
                    :href="sow.msaFileInfo.webURl"
                    target="_blank"
                    class="card-link"
                  >
                    <font-awesome-icon
                      class="mx-1 text-info"
                      :icon="['fas', 'file-word']"
                      size="lg"
                    />MSA
                  </a>
                  <font-awesome-icon
                    class="ml-2"
                    :icon="['fas', 'download']"
                    @click="handleDownload(sow.msaFileInfo)"
                    size="sm"
                  />
                </span>

                <div class="d-inline ml-2 float-right">
                  <span
                    v-b-popover.hover.top="
                      sow.incidentType == 'it-mdr'
                        ? 'Create Renewal Contract'
                        : 'Create Amendment'
                    "
                  >
                    <font-awesome-icon
                      v-if="!sow.IsFinalised"
                      class="ml-2"
                      :icon="['fas', 'plus-circle']"
                      size="sm"
                      @click="a(sow.clientName, sow.slug, sow.incidentType)"
                    />
                  </span>
                </div>
              </div>
              <!-- <a href="#" class="card-link">SoW Details</a> -->
            </div>
            <div class="p-2 card-footer text-muted">
              <small>
                Created On {{ sow.createdAt | formatDateTime }}
                <br />
                By {{ sow.createdBy ? sow.createdBy.name : "" }}
              </small>
            </div>
          </div>
        </div>
        <div
          v-if="sows.length === 0"
          class="w-100 mx-0 my-2 px-2 d-block alert alert-info"
          role="alert"
        >
          No SoWs generated for the selected Client
        </div>
      </div>
      <button class="btn btn-secondary" @click="goback">
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon
        >Back
      </button>
      <button
        class="btn btn-info mx-2"
        v-if="
          sows.length === 0 &&
          this.$store.getters.selectedDocumenttype == 'MDR Renewals'
        "
        @click="newmdrrenewal"
      >
        Generate New MDR Renewal
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
    <b-modal id="bv-modal-example" hide-footer>
      <template v-slot:modal-title>Are you sure?</template>
      <div class="d-block text-center">
        <h4>{{ modalTitle }}</h4>
      </div>
      <div class="d-flex justify-content-center">
        <b-button class="mt-3 mr-1 btn-secondary" @click="no()">No</b-button>
        <b-button class="mt-3 mr-1 btn-info" @click="yes()">Yes</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import moment from "moment";
export default {
  created() {
    let that = this;
    let selectedDocument =
      this.$store.getters.selectedDocumenttype.toUpperCase();
    let documentType = _.clone(selectedDocument);
    that.$root.$emit("removestage");
    that.getClientSows();
  },
  filters: {
    uppercase: function (value, onlyFirstCharacter) {
      if (!value) {
        return "";
      }
      value = value.toString();
      if (onlyFirstCharacter) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      } else {
        return value.toUpperCase();
      }
    },
  },
  data() {
    return {
      documenttype: "",
      country: "",
      sowClients: [],
      selectedClient: "",
      createAgainMode: this.$store.getters.createAgainMode,
      activeSows: [],
      masterData: {},
      lawfirm: "",
      lawfirmtitle: "",
      services: [],
      sows: [],
      modalTitle: "",
      cursow: "",
      curaction: "",
      search: "",
      templateConfig: null,
    };
  },
  computed: {
    nextable() {
      return false;
    },
  },
  methods: {
    goback: function () {
      this.$router.go(-1);
    },
    newmdrrenewal: function () {
      this.$store.commit("newMdrRenewal", true);
      this.$router.push({
        path: "select-template",
      });
    },
    getClientSows() {
      let that = this;
      let clientName = that.$store.getters.selectedClient.name
        ? that.$store.getters.selectedClient.name
        : that.$store.getters.selectedManualClient;
      if (clientName) {
        that.$root.$emit("progress");
        that.$root.$emit("toast", {
          title: "Fetching Data",
          message: "Fetching ClientSows",
        });
        serviceProxy.sow
          .getClientSows(this.$store.getters.token, clientName)
          .then((data) => {
            let response = data.data.data;
            _.forEach(response, (element) => {
              _.forEach(that.$store.getters.masterData.lawfirms, (melement) => {
                if (melement.slug == element.lawfirm) {
                  element.lawfirmTitle = melement.title;
                }
              });
            });
            that.activeSows = _.clone(response);
            that.sows = _.clone(response);
            let clientDetails = {
              clientName: _.clone(clientName),
              activeSows: _.clone(response),
            };
            that.$store.commit("selectedClientDetails", clientDetails);
            that.$root.$emit("done");
            that.$root.$emit("toast", {
              title: "Fetched Sows",
              message: "Fetched ClientSows",
            });
          })
          .catch((e) => {
            that.$root.$emit("done");
            that.$root.$emit("toast", {
              title: "OOPS",
              message: "Error in fetching the ClientSows",
            });
          });
      } else {
        let that = this;
        let sows = this.$store.getters.selectedClientDetails;
        this.selectedClient = sows.clientName;
        that.activeSows = _.clone(sows.activeSows);
        that.sows = _.clone(sows.activeSows);
      }
    },
    gonext: function () {
      var that = this;
      this.$router.push({ path: this.documenttype });
    },
    a(clientName, slug, incidentType) {
      this.cursow = slug;
      this.modalTitle =
        "Are you sure you want to generate the " +
        (incidentType == "it-mdr" ? "renewal contract" : "Amendment") +
        " for - " +
        clientName;
      this.curaction = "a"; //f-finalize, t-trash, r-redo, d-download
      this.$bvModal.show("bv-modal-example");
    },

    downloadSow(clientName, slug) {
      let that = this;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading",
        message: "Downloading SoW",
      });
      serviceProxy.sow
        .download(this.$store.getters.token, slug)
        .then((response) => {
          let sow = _.find(that.sows, (sow) => sow.Slug === slug);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            sow.filename ? sow.filename : sow.Slug + ".docx"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.cursow = "";
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Downloaded",
            message: "SoW Downloaded",
          });
        })
        .catch((er) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Oops",
            message: "Error in downloading the SoW",
          });
          that.cursow = "";
        });
    },
    downloadMSA(clientName, slug) {
      let that = this;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading",
        message: "Downloading MSA",
      });
      serviceProxy.sow
        .downloadMSA(this.$store.getters.token, slug)
        .then((response) => {
          let sow = _.find(that.sows, (sow) => sow.Slug === slug);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            sow.msafilename ? sow.msafilename : sow.Slug + ".docx"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.cursow = "";
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Downloaded",
            message: "MSA Downloaded",
          });
        })
        .catch((er) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Oops",
            message: "Error in downloading the MSA",
          });
          that.cursow = "";
        });
    },
    handleDownload(fileInfo) {
      let that = this;
      let FileId = fileInfo.fileId;
      let FileName = fileInfo.fileName;
      that.$root.$emit("toast", {
        title: "Downloading",
        message: "Downloading SoW",
      });
      serviceProxy.sow
        .download(this.$store.getters.token, FileId, FileName)
        .then((data) => {
          var fileURL = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", FileName, FileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: " Document download",
            message: " Document downloaded",
          });
        })
        .catch((e) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error downloading",
          });
        });
    },
    no() {
      this.cursow = "";
      this.modalTitle = "";
      this.curaction = "";
      this.$bvModal.hide("bv-modal-example");
    },
    yes() {
      //f-finalize, t-trash, r-redo, d-download
      switch (this.curaction) {
        case "a":
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          let amendmentsow = _.find(
            this.sows,
            (sow) => sow.slug === this.cursow
          );
          if (amendmentsow) {
            //Old Sow dosen't have Country
            amendmentsow.data.state.masterData.lawfirms =
              this.$store.getters.masterData.lawfirms;
            amendmentsow.data.state.masterData.countries =
              this.$store.getters.masterData.countries;
            amendmentsow.data.state.masterData.documents =
              this.$store.getters.masterData.documents;
            amendmentsow.data.state.masterData.subofferingTypes =
              this.$store.getters.masterData.subofferingTypes;
            amendmentsow.data.state.masterData.authorities =
              this.$store.getters.masterData.authorities;
            amendmentsow.data.state.masterData.incidentTypes =
              this.$store.getters.masterData.incidentTypes;
            let serviceslugs = [];
            let servicesss = [];
            _.each(
              amendmentsow.data.state.selectedServices,
              (selSer, index) => {
                selSer.isSelected = false;
                selSer.isOptional = false;
              }
            );
            _.each(
              this.$store.getters.masterData.services,
              function (item, index) {
                // if (
                //   !_.find(
                //     amendmentsow.data.state.masterData.services,
                //     (serv) => serv.slug === item.slug
                //   )
                // ) {
                servicesss.push(item);
                serviceslugs.push(item.slug);
                // }
              }
            );
            serviceProxy.template
              .getTemplate(
                this.$store.getters.token,
                amendmentsow.lawfirm,
                amendmentsow.subOfferingType
              )
              .then((response) => {
                this.templateConfig = response.data.data.masterServiceConfig;
                serviceProxy.serviceConfig
                  .getConfig(
                    this.$store.getters.token,
                    serviceslugs.join(","),
                    this.templateConfig
                  )
                  .then((data) => {
                    let servicesConfig = data.data.data;
                    for (
                      let index = 0;
                      index < servicesConfig.length;
                      index++
                    ) {
                      const element = servicesConfig[index];
                      const selService = _.find(servicesss, (ser) => {
                        return ser.slug === element.serviceId;
                      });
                      element.isOptional = selService.isOptional;
                      selService.serviceConfig = element;
                      selService.serviceConfig.additionalScopes = [];
                      //element.serviceTitle = element.isOptional ? `OPTIONAL - ${selService.Title}` : `${selService.Title}`;
                      let sConfig = this.$store.getters.servicesConfig;
                      amendmentsow.data.state.masterData.services = _.reject(
                        amendmentsow.data.state.masterData.services,
                        ["slug", selService.slug]
                      );
                      amendmentsow.data.state.servicesConfig = _.reject(
                        amendmentsow.data.state.servicesConfig,
                        ["serviceId", selService.slug]
                      );
                      sConfig = _.reject(sConfig, [
                        "serviceId",
                        selService.slug,
                      ]);
                      if (sConfig) {
                        sConfig.push(element);
                        this.$store.commit("servicesConfig", sConfig);
                      }
                      amendmentsow.data.state.masterData.services.push(
                        selService
                      );
                      amendmentsow.data.state.servicesConfig.push(element);
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                    this.$root.$emit("done");
                  });
              })
              .catch((e) => {
                console.log(e);
                this.$root.$emit("done");
              });
            amendmentsow.data.state.IsAmendment = true;
            amendmentsow.data.state.SoWSlug = this.cursow;
            let amendmentsowPlaceholders = _.map(
              amendmentsow.data.placeHolders,
              (ph) => {
                return {
                  slug: ph.name === "sowdate" ? "msadate" : ph.name,
                  Value: ph.value,
                };
              }
            );
            let oldsowdate = _.filter(
              amendmentsowPlaceholders,
              (mr) => mr.slug === "msadate"
            );
            amendmentsow.data.state.placeholdervalues = _.clone(
              _.union(amendmentsow.data.state.placeholdervalues, oldsowdate)
            );
            this.$store.commit("initSoW", amendmentsow.data.state);
            this.$router.push({
              path: "select-template",
            });
          }
          break;
        default:
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          this.cursow = "";
          break;
      }
    },
  },
};
</script>
<style scoped>
</style>

